// Shared validation for profile / advice image uploads.
//
// The back end limits the uploaded picture payload to 5,000,000 characters
// (see UpdateOwnPictureRequest.PictureSize `lte=5000000`). The profile-picture
// flow uploads the image as a base64 data URL, which inflates the raw binary by
// roughly 4/3 plus a small data-URL prefix. To give the user a clear error
// *before* the request instead of a backend rejection, we cap the raw file well
// below that limit.

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']

// ~3.5 MB of raw binary → ~4.7 MB of base64, staying under the 5,000,000 limit.
export const MAX_IMAGE_BYTES = 3_500_000

const formatMb = (bytes: number) => `${(bytes / 1_000_000).toFixed(1)} MB`

/**
 * Validates an image File selected for upload.
 * Returns a human-readable error message, or null when the file is valid.
 */
export const validateImageFile = (file?: File | null): string | null => {
  if (!file) {
    return 'No file selected.'
  }

  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return 'Unsupported file type. Please choose a JPEG, PNG, or WebP image.'
  }

  if (file.size > MAX_IMAGE_BYTES) {
    return `Image is too large (${formatMb(file.size)}). Please choose one smaller than ${formatMb(
      MAX_IMAGE_BYTES
    )}.`
  }

  return null
}
